var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeptune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#000",
      strokeWidth: 2,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(4 3)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.74452631 2.12226316c-1.25285594 8.33333334 1.41381072 12.50000004 7.99999999 12.50000004 6.5861893 0 9.252856-4.1666667 8-12.50000004"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.788644 4.38921484-.0882353 19.30870946"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.7445263 19.6222632h-9.99999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m8 5.74452631 2.7445263-2.24452631 2.7445263 2.24452631"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m0 2.24452631 2.74452631-2.24452631 2.74452632 2.24452631"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m16 2.24452631 2.7445263-2.24452631 2.7445263 2.24452631"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeptune);
export default __webpack_public_path__ + "static/media/neptune.1ec90340e6c17ed029b822e71145568c.svg";
export { ForwardRef as ReactComponent };